import { faReply, faSync, faUser } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState } from "react";
import { getStatusIcon } from "./SupportTicketHelper";
import { toast } from "react-toastify";
import axios from "axios";
import LongText from "./LongText";
import { API, fileUpload } from "../../../config";
import {
  checkRole,
  formatSubcontractorName,
  formatUTCToLocal,
} from "../../../lib/Misc";
import Spin from "../../../components/Spin";
import { Button } from "../../../components/ui/button";
import { ResponsiveDrawerForm } from "../../../components/ResponsiveDrawerForm";
import Confirmation from "../../../components/Confirmation";
import { Card, CardContent, CardHeader } from "../../../components/ui/card";
import { Label } from "../../../components/ui/label";
import CustomLabelText from "../../../components/CustomLabelText";
import Editor from "../../../components/Editor";
import { LucidePlusCircle, X } from "lucide-react";
import { Badge } from "../../../components/ui/badge";
import FaviconSVG from "../../../components/FaviconSVG";
const SupportTicketView = ({
  showView,
  setShowView,
  setShowFetch,
  loading,
  supportDetail,
  id,
  fetchData,
  setReplay,
  reply,
  fetchSupportTickets,
  toggleShowModal,
}) => {
  const roleType = localStorage.getItem("roleType");
  const [message, setMessage] = useState([]);
  const [files, setFiles] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [statusModal, setStatusModal] = useState(false);
  const [status, setStatus] = useState();

  const toggleStatusModal = (status) => {
    if (statusModal) {
      setStatus("");
    } else {
      setStatus(status);
    }
    setStatusModal(!statusModal);
  };

  const toggleReplayInput = () => {
    setReplay(!reply);
  };

  const handleUpload = async () => {
    setIsLoading(true);
    const formData = new FormData();
    // const value = draftToHtml(convertToRaw(editorState.getCurrentContent()));
    formData.append("message", message);
    formData.append("_method", "put");
    files.forEach((file, index) => {
      if (file !== undefined) {
        formData.append(`attachments[${index}]`, file);
      }
    });
    const config = { headers: { "Content-Type": "multipart/form-data" } };
    fileUpload(
      checkRole(roleType)
        ? `${API.ADMIN_SUPPORT_TICKET}/${id}`
        : `${API.SUPPORT_TICKET}/${id}`,
      formData,
      config
    )
      .then((response) => {
        if (response.status === 200) {
          setIsLoading(false);
          setFiles([]);
          toggleReplayInput();
          fetchData();
          fetchSupportTickets();
        }
      })
      .catch((err) => {
        setIsLoading(false);
      });
  };

  const handleStatus = async (status) => {
    setIsLoading(true);
    const formData = new FormData();
    if (status === "isResolved") {
      formData.append("is_resolved", 1);
    } else {
      formData.append("status", status);
    }
    formData.append("_method", "put");
    const config = { headers: { "Content-Type": "multipart/form-data" } };
    fileUpload(
      checkRole(roleType)
        ? `${API.ADMIN_SUPPORT_TICKET}/${id}`
        : `${API.SUPPORT_TICKET}/${id}`,
      formData,
      config
    )
      .then((response) => {
        if (response.status === 200) {
          setIsLoading(false);
          setFiles([]);
          toggleReplayInput();
          fetchData();
          toggleStatusModal();
          fetchSupportTickets();
        }
      })
      .catch((err) => {
        setIsLoading(false);
      });
  };

  const downloadAttachments = async (files) => {
    for (let fileIndex = 0; fileIndex < files?.length; fileIndex++) {
      const response = await axios.get(files[fileIndex]?.file, {
        responseType: "blob",
      });
      const fileData = response.data;
      const url = window.URL.createObjectURL(new Blob([fileData]));
      var a = document.createElement("a");
      a.href = url;
      var file = files[fileIndex]?.file.split("/");
      a.setAttribute("download", file[file.length - 1] || "attachment");
      document.body.appendChild(a); // we need to append the element to the dom -> otherwise it will not work in firefox
      a.click();
      a.remove();
    }
  };

  const allowedFileTypes = [
    "application/pdf",
    "image/jpeg",
    "image/png",
    "image/gif",
    "image/bmp",
    "application/msword", // .doc
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document", // .docx
    "application/vnd.ms-excel", // .xls
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", // .xlsx
    "text/csv", // .csv
  ];

  const handleAddFiles = (event) => {
    const files = Array.from(event.target.files);
    const invalidFiles = files.filter(
      (file) => !allowedFileTypes.includes(file.type)
    );

    if (invalidFiles.length > 0) {
      toast({
        variant: "destructive",
        description: `Invalid file type(s): ${invalidFiles
          .map((file) => file.name)
          .join(
            ", "
          )}. Please upload PDF, images, Word, Excel, or CSV files only.`,
        duration: 3000,
      });
    } else {
      setFiles((prev) => [...prev, ...files]);
    }
  };

  // Handle file removal
  const handleRemoveFile = (fileIndex) => {
    setFiles((prevAttachments) =>
      prevAttachments.filter((_, index) => index !== fileIndex)
    );
  };

  return (
    <>
      <ResponsiveDrawerForm
        description={""}
        title={"View Support Ticket"}
        handleOpen={() => {}}
        handleClose={() => {
          setShowFetch && setShowFetch(true);
        }}
        buttonText={""}
        className={""}
        open={showView}
        buttonClassName={""}
        setOpen={setShowView}
        mobileCancelHidden={true}
      >
        {loading ? (
          <Spin expand={true} />
        ) : (
          supportDetail && (
            <>
              <div className="support-ticket-view md:p-0 p-4">
                <div className="flex items-center gap-2 mb-2">
                  <div className="ticket-number">
                    #{supportDetail?.support_ticket_id}
                  </div>
                  <div> | </div>
                  <div className="ticket-subject-body">
                    <span className="ticket-subject">
                      {supportDetail?.subject}
                    </span>
                  </div>
                  <FontAwesomeIcon
                    icon={faSync}
                    className="reply-sync-btn"
                    onClick={() => {
                      fetchData();
                    }}
                  />
                </div>

                <div className="grid md:grid-cols-1 lg:grid-cols-3 lg:gap-2 gap-4">
                  <Card className="max-w-full">
                    <CardHeader className="p-3 pb-2">
                      <div className="flex items-center justify-between flex-wrap">
                        <span className="ticket-card-title">
                          {supportDetail?.status
                            ? getStatusIcon(
                                supportDetail?.status?.toString(),
                                supportDetail?.is_resolved
                              )
                            : ""}{" "}
                        </span>
                        {Number(supportDetail?.status) !== 4 &&
                          Number(supportDetail?.status) !== 1 && (
                            <div className="flex items-center gap-3">
                              {supportDetail?.is_resolved ? (
                                <Button
                                  onClick={() => {
                                    toggleStatusModal("2");
                                  }}
                                  className="status-btn"
                                >
                                  Open
                                </Button>
                              ) : (
                                <Button
                                  onClick={() => {
                                    toggleStatusModal("isResolved");
                                  }}
                                  className="status-btn"
                                >
                                  Resolve
                                </Button>
                              )}
                              <Button
                                onClick={() => {
                                  toggleStatusModal("4");
                                }}
                                className="status-btn"
                              >
                                Mark As Closed
                              </Button>
                            </div>
                          )}
                      </div>
                    </CardHeader>
                    <CardContent className="p-3 pt-0">
                      {checkRole(roleType) && (
                        <>
                          <hr className="mt-2" />
                          <div className="my-2">
                            <h3 className="text-webPrimary mb-1">Trust</h3>
                            <p className="ticket-card-message">
                              {formatSubcontractorName(supportDetail?.trust)}
                            </p>
                          </div>
                        </>
                      )}
                      <hr />
                      <div className="my-2">
                        <h3 className="text-webPrimary mb-1">Subject</h3>
                        <p className="ticket-card-message">
                          {supportDetail?.subject}
                        </p>
                      </div>
                      <hr />
                      <div className="my-2">
                        <h3 className="text-webPrimary mb-1">Description</h3>
                        <div className="ticket-card-message">
                          {" "}
                          <LongText
                            content={
                              supportDetail?.details?.message
                                ? supportDetail?.details?.message
                                : ""
                            }
                            maxLength={350}
                          />
                        </div>
                      </div>
                      {supportDetail?.details?.support_ticket_comment_files
                        ?.length !== 0 && (
                        <div className="flex w-full justify-end text-webPrimary cursor-pointer">
                          <span
                            onClick={() => {
                              downloadAttachments(
                                supportDetail?.details
                                  ?.support_ticket_comment_files
                              );
                            }}
                          >
                            {
                              supportDetail?.details
                                ?.support_ticket_comment_files?.length
                            }{" "}
                            Attachment(s)
                          </span>
                        </div>
                      )}
                    </CardContent>
                  </Card>
                  <Card className="max-w-full lg:col-span-2">
                    <CardContent className="p-3">
                      <div className="support-ticket-thread">
                        {Number(supportDetail?.status) !== 4 && (
                          <Button
                            className={"mb-3"}
                            variant={reply ? "default" : "outline"}
                            onClick={() => {
                              toggleReplayInput();
                            }}
                          >
                            <div className="flex items-center gap-2">
                              <FontAwesomeIcon icon={faReply} /> Reply
                            </div>
                          </Button>
                        )}
                        {reply && (
                          <div className="relative border p-2.5 rounded-md mb-3">
                            <div className="grid p-1 gap-3">
                              <div className="grid gap-2 col-span-full">
                                <Label htmlFor="message">
                                  <CustomLabelText labelText="Message" />
                                </Label>
                                <Editor
                                  value={message}
                                  setValue={(data) => setMessage(data)}
                                />
                              </div>

                              <div className="form-group full-width">
                                <div className="attachment-button">
                                  <input
                                    type="file"
                                    className="form-control"
                                    multiple
                                    onChange={handleAddFiles}
                                    accept=".pdf, image/*, .xls, .xlsx, .doc, .docx, .csv"
                                    style={{ display: "none" }}
                                    id="file-input"
                                  />
                                  <Button
                                    onClick={() =>
                                      document
                                        .getElementById("file-input")
                                        .click()
                                    }
                                    className="p-2 h-7"
                                  >
                                    <div className="flex items-center gap-1">
                                      <LucidePlusCircle size={18} />{" "}
                                      <span>Attachment</span>
                                    </div>
                                  </Button>
                                </div>
                                {files.length > 0 && (
                                  <div className="flex flex-wrap gap-2 mt-2">
                                    {/* New Uploads */}
                                    {files.map((file, index) => (
                                      <Badge
                                        key={index}
                                        variant="secondary"
                                        className="flex items-center gap-1 pr-2"
                                      >
                                        <span
                                          title={file.name}
                                          className="cursor-pointer"
                                        >
                                          {file.name}
                                        </span>
                                        <X
                                          className="w-4 h-4 ml-1 cursor-pointer"
                                          onClick={() =>
                                            handleRemoveFile(index)
                                          }
                                        />
                                      </Badge>
                                    ))}
                                  </div>
                                )}
                              </div>
                              <div className="modal-footer pt-4 border-t mt-4 flex items-center justify-end">
                                <Button
                                  disabled={isLoading}
                                  onClick={() => handleUpload()}
                                >
                                  {isLoading ? "Loading..." : "Submit"}
                                </Button>
                                <Button
                                  variant="secondary"
                                  onClick={() => toggleReplayInput()}
                                  className="ml-3"
                                >
                                  Cancel
                                </Button>
                              </div>
                            </div>
                          </div>
                        )}

                        {/* Map the List of Replay */}
                        {supportDetail?.support_ticket_comments?.length !== 0 &&
                          supportDetail?.support_ticket_comments?.length !==
                            1 && (
                            <div className="flex flex-col gap-4">
                              {supportDetail?.support_ticket_comments?.map(
                                (item, index) => (
                                  <>
                                    {index !==
                                      supportDetail?.support_ticket_comments
                                        ?.length -
                                        1 && (
                                      <div
                                        key={index}
                                        className={
                                          item?.replied_by?.role?.type !==
                                          "Admin"
                                            ? "bg-white text-black relative border p-2.5 rounded-md"
                                            : "bg-white text-black relative border p-2.5 rounded-md border-webPrimary"
                                        }
                                      >
                                        <div className="reply-header flex items-center justify-between w-full text-webPrimary text-sm">
                                          <div className="font-bold">
                                            {item?.created_at ? (
                                              <>
                                                {formatUTCToLocal(
                                                  item?.updated_at,
                                                  true
                                                )}
                                              </>
                                            ) : (
                                              ""
                                            )}
                                          </div>
                                          <div className="icon-replay">
                                            {item?.replied_by?.role?.type !==
                                            "Admin" ? (
                                              <FontAwesomeIcon icon={faUser} />
                                            ) : (
                                              <FaviconSVG className="w-9 h-9 !text-webPrimary !fill-webPrimary" />
                                            )}
                                          </div>
                                        </div>

                                        <LongText
                                          content={
                                            item?.message ? item?.message : ""
                                          }
                                          className={"text-md"}
                                          maxLength={350}
                                        />
                                        <div className="reply-footer pt-3">
                                          <div className="replied-by">
                                            <div>Thank You,</div>
                                            <span className="to-name-text">
                                              {item?.replied_by?.first_name
                                                ? item?.replied_by?.first_name +
                                                  " " +
                                                  item?.replied_by?.last_name
                                                : item?.replied_by?.last_name}
                                            </span>
                                            <div>TrustSoft Support</div>
                                          </div>
                                          {item?.support_ticket_comment_files
                                            ?.length !== 0 && (
                                            <div className="attachment-section">
                                              <span
                                                onClick={() => {
                                                  downloadAttachments(
                                                    item?.support_ticket_comment_files
                                                  );
                                                }}
                                                className="text-webPrimary cursor-pointer"
                                              >
                                                {
                                                  item
                                                    ?.support_ticket_comment_files
                                                    ?.length
                                                }{" "}
                                                Attachment(s)
                                              </span>
                                            </div>
                                          )}
                                        </div>
                                      </div>
                                    )}
                                  </>
                                )
                              )}
                            </div>
                          )}
                      </div>
                    </CardContent>
                  </Card>
                </div>
              </div>
            </>
          )
        )}
      </ResponsiveDrawerForm>
      <Confirmation
        title={" Change Ticket Status"}
        open={statusModal}
        setOpen={setStatusModal}
        toggleShow={() => {
          toggleStatusModal();
        }}
        className="sm:max-w-fit"
        message={"Do you want to change the status of ticket?"}
        okAction={async () => {
          await handleStatus(status);
        }}
        loading={isLoading}
        cancelAction={() => {
          toggleStatusModal();
        }}
      />
    </>
  );
};

export default SupportTicketView;
